export const APP_ROUTE_SEGMENTS = {
  home: 'home',
  geoAeo: 'geo-aeo',
  adminConsole: 'admin-console',
  benchmarkUrlAnalysis: 'benchmark-url-analysis',
} as const;

export const APP_ROUTE_PATHS = {
  home: `/${APP_ROUTE_SEGMENTS.home}`,
  geoAeo: `/${APP_ROUTE_SEGMENTS.geoAeo}`,
  adminConsole: `/${APP_ROUTE_SEGMENTS.adminConsole}`,
  benchmarkUrlAnalysis: `/${APP_ROUTE_SEGMENTS.benchmarkUrlAnalysis}`,
} as const;

export interface AppNavItem {
  label: string;
  path: string;
  icon: string;
  adminOnly?: boolean;
  activePathPrefixes?: string[];
  featureFlag?: 'showGeoAeoPage' | 'showAdminConsolePage';
}

export const APP_NAV_ITEMS: AppNavItem[] = [
  {
    label: 'URL Analysis',
    path: APP_ROUTE_PATHS.home,
    icon: 'pi pi-search',
    activePathPrefixes: [APP_ROUTE_PATHS.benchmarkUrlAnalysis],
  },
  {
    label: 'AEO/GEO Analysis',
    path: APP_ROUTE_PATHS.geoAeo,
    icon: 'pi pi-sitemap',
    featureFlag: 'showGeoAeoPage',
  },
  {
    label: 'Admin Console',
    path: APP_ROUTE_PATHS.adminConsole,
    icon: 'pi pi-shield',
    adminOnly: true,
    featureFlag: 'showAdminConsolePage',
  },
];
